export default __webpack_public_path__ + "static/media/monkey15.a8a3432d.jpeg";